// ========== 怪物数据库 ==========
export function getMonsterData(id) {
  const monsters = {
    goblin:        { name:'哥布林',
    dieSfx: 'sfx_mon_die_goblin',       hp:32,  atk:4,  def:1,  gold:6,   exp:12,  lv:1,  color:'#aaa' },
    goblin2:       { name:'哥布林哨兵',
    dieSfx: 'sfx_mon_die_goblin2',   hp:45,  atk:6,  def:2,  gold:10,  exp:18,  lv:2,  color:'#aaa' },
    goblin_chief:  { name:'哥布林头目',
    dieSfx: 'sfx_mon_die_goblin_chief',   hp:130, atk:12, def:4,  gold:45,  exp:65,  lv:3,  color:'var(--blue)', isBoss:true },
    tau_beast:     { name:'牛头兵',
    dieSfx: 'sfx_mon_die_tau_beast',       hp:100, atk:11, def:4,  gold:35,  exp:55,  lv:5,  color:'var(--purple)' },
    tau_chief:     { name:'牛头王',
    dieSfx: 'sfx_mon_die_tau_chief',       hp:350, atk:24, def:9,  gold:200, exp:300, lv:8,  color:'var(--purple)', isBoss:true },
    zombie:        { name:'暗黑僵尸',
    dieSfx: 'sfx_mon_die_zombie',     hp:60,  atk:10, def:2,  gold:20,  exp:35,  lv:4,  color:'#999' },
    zombie2:       { name:'腐尸',
    dieSfx: 'sfx_mon_die_zombie2',         hp:75,  atk:11, def:3,  gold:25,  exp:40,  lv:5,  color:'#999' },
    thunder_goblin:{ name:'雷霆哥布林',
    dieSfx: 'sfx_mon_die_thunder_goblin',
    dieSfx: 'sfx_mon_die_goblin',   hp:130, atk:15, def:5,  gold:75,  exp:95,  lv:7,  color:'var(--blue)' },
    thunder_boss:  { name:'落雷凯诺',     hp:420, atk:30, def:10, gold:320, exp:400, lv:9,  color:'var(--purple)', isBoss:true },
    poison_slime:  { name:'猛毒史莱姆',
    dieSfx: 'sfx_mon_die_poison_slime',   hp:170, atk:17, def:6,  gold:95,  exp:120, lv:8,  color:'#8a2', statusAtk:'poison', isBoss:true },
    flame_goblin:  { name:'烈焰哥布林',
    dieSfx: 'sfx_mon_die_flame_goblin',
    dieSfx: 'sfx_mon_die_goblin',   hp:140, atk:16, def:5,  gold:85,  exp:110, lv:10, color:'var(--orange)' },
    flame_boss:    { name:'烈焰彼诺修',   hp:520, atk:35, def:11, gold:450, exp:520, lv:12, color:'var(--pink)', isBoss:true, multiPhase:true, phase2Hp:200, phase2AtkBonus:15, bossSkill:{name:"烈焰风暴",desc:"全屏火焰AOE，造成1.5倍攻击伤害",mult:1.5,aoe:true,rate:0.25}, bossPassive:{name:"火焰之躯",desc:"每回合回复5HP",regen:5} },
    bone_dragon:   { name:'盗尸者骨狱息',
    dieSfx: 'sfx_mon_die_bone_dragon', hp:700, atk:42, def:14, gold:700, exp:850, lv:15, color:'var(--red)', isBoss:true, multiPhase:true, phase2Hp:250, phase2AtkBonus:20, bossSkill:{name:"死亡寒气",desc:"冰霜吐息，造成1.3倍伤害并冰冻1回合",mult:1.3,freeze:1,rate:0.3}, bossPassive:{name:"不死亡骨",desc:"减伤25%",dmgReduce:0.25} },
    cursed_knight: { name:'被诅咒的骑士',
    dieSfx: 'sfx_mon_die_cursed_knight', hp:200, atk:22, def:9,  gold:120, exp:160, lv:14, color:'var(--purple)' },
    shadow_mage:   { name:'暗影法师',
    dieSfx: 'sfx_mon_die_shadow_mage',     hp:160, atk:26, def:6,  gold:110, exp:150, lv:13, color:'var(--blue)', statusAtk:'curse' },
    golem_guard:   { name:'地界守卫者',
    dieSfx: 'sfx_mon_die_golem_guard',   hp:600, atk:36, def:17, gold:420, exp:550, lv:16, color:'var(--purple)', isBoss:true, multiPhase:true, phase2Hp:250, phase2AtkBonus:12, bossSkill:{name:"大地震撼",desc:"地面震击，防御力+5持续3回合",buffSelf:{stat:"def",val:5,dur:3},rate:0.3}, bossPassive:{name:"岩石铠甲",desc:"50%概率格挡30%伤害",blockChance:0.5,blockAmount:0.3} },
    ice_witch:     { name:'冰封女巫',
    dieSfx: 'sfx_mon_die_ice_witch',     hp:480, atk:38, def:12, gold:380, exp:480, lv:17, color:'var(--blue)', isBoss:true, multiPhase:true, phase2Hp:180, phase2AtkBonus:18, bossSkill:{name:"极寒风暴",desc:"全场冰冻，玩家被冻1回合",stunPlayer:1,rate:0.25}, bossPassive:{name:"冰霜护盾",desc:"每3回合获得1回合格挡",shieldCycle:3}, statusAtk:'freeze' },
    cloud_gargoyle:{ name:'云海石像鬼',
    dieSfx: 'sfx_mon_die_cloud_gargoyle',   hp:280, atk:30, def:12, gold:180, exp:240, lv:18, color:'#8aa', isBoss:true, multiPhase:true, phase2Hp:100, phase2AtkBonus:12, bossSkill:{name:"旋风突袭",desc:"一回合攻击两次",doubleAtk:true,rate:0.25}, bossPassive:{name:"石像形态",desc:"血量低于30%时防御翻倍",lowHpDef:true} },
    storm_hawk:    { name:'风暴战鹰',
    dieSfx: 'sfx_mon_die_storm_hawk',     hp:240, atk:35, def:8,  gold:160, exp:220, lv:19, color:'var(--blue)' },
    angel_fallen:  { name:'堕落天使',
    dieSfx: 'sfx_mon_die_angel_fallen',     hp:650, atk:46, def:17, gold:520, exp:700, lv:20, color:'var(--pink)', isBoss:true },
    sky_dragon:    { name:'天空龙王',
    dieSfx: 'sfx_mon_die_sky_dragon',     hp:1000, atk:52, def:18, gold:1000, exp:1300, lv:25, color:'var(--red)', isBoss:true, multiPhase:true, phase2Hp:400, phase2AtkBonus:25, bossSkill:{name:"龙神之怒",desc:"终极吐息，2.0倍伤害",mult:2.0,rate:0.2}, bossPassive:{name:"龙威",desc:"每回合减少玩家5MP",mpDrain:5} },
    arad_demon:    { name:'阿拉德魔王',
    dieSfx: 'sfx_mon_die_arad_demon', hp:1600, atk:70, def:24, gold:2000, exp:2600, lv:30, color:'var(--red)', isBoss:true,
                     multiPhase:true, phase2Hp:800, phase2AtkBonus:20 },
    // === 格兰之森 新增 ===
    cat_demon:     { name:'猫妖',
    dieSfx: 'sfx_mon_die_cat_demon',         hp:50,  atk:7,  def:2,  gold:14, exp:22,  lv:3,  color:'#7a6' },
    goblin_scout:  { name:'哥布林侦察兵',
    dieSfx: 'sfx_mon_die_goblin_scout', hp:95,  atk:13, def:4,  gold:38, exp:52,  lv:6,  color:'#aaa' },
    wild_boar:     { name:'狂暴野猪',     hp:90,  atk:12, def:5,  gold:22, exp:36,  lv:5,  color:'#964' },
    swamp_zombie:  { name:'沼泽腐尸',
    dieSfx: 'sfx_mon_die_swamp_zombie',
    dieSfx: 'sfx_mon_die_zombie',     hp:110, atk:12, def:4,  gold:34, exp:48,  lv:6,  color:'#686' },
    dark_cat:      { name:'暗咒猫妖',
    dieSfx: 'sfx_mon_die_dark_cat',     hp:120, atk:15, def:5,  gold:62, exp:88,  lv:8,  color:'#704', statusAtk:'curse' },
    goblin_shaman: { name:'哥布林萨满',
    dieSfx: 'sfx_mon_die_goblin_shaman',   hp:70,  atk:8,  def:3,  gold:30, exp:42,  lv:4,  color:'#5a9', statusAtk:'poison' },
    forest_guardian:{ name:'森林守护者',  hp:460, atk:30, def:13, gold:360, exp:460, lv:11, color:'#5a8', isBoss:true,
                     desc:'格兰之森的远古守护灵，藤蔓缠绕的木巨人。' },
    // === 赫顿玛尔 新增 ===
    puppet_master:  { name:'疯狂人偶师',  hp:150, atk:18, def:6,  gold:90,  exp:125, lv:11, color:'#96a' },
    dark_elf_archer:{ name:'暗精灵弓箭手',hp:140, atk:24, def:4,  gold:100, exp:135, lv:12, color:'#68a', spdBonus:4 },
    gbl_zealot:     { name:'GBZ狂热教徒', hp:175, atk:20, def:7,  gold:110, exp:155, lv:13, color:'#f80' },
    dark_sorcerer:  { name:'暗黑术士',
    dieSfx: 'sfx_mon_die_dark_sorcerer',    hp:130, atk:30, def:4,  gold:120, exp:165, lv:14, color:'#509', statusAtk:'curse' },
    stone_golem:    { name:'石巨人',
    dieSfx: 'sfx_mon_die_stone_golem',     hp:250, atk:22, def:17, gold:135, exp:180, lv:15, color:'#887' },
    mad_alchemist:  { name:'疯狂炼金师',  hp:420, atk:34, def:10, gold:300, exp:400, lv:17, color:'#f80', isBoss:true,
                     statusAtk:'poison', desc:'赫顿玛尔地下实验室的疯子，周身毒雾缭绕。' },
    // === 天空之城 新增 ===
    dragon_warrior: { name:'龙人战士',
    dieSfx: 'sfx_mon_die_dragon_warrior',    hp:290, atk:33, def:14, gold:175, exp:235, lv:19, color:'#b82' },
    sky_patrol:     { name:'天空巡游者',  hp:310, atk:35, def:12, gold:195, exp:265, lv:21, color:'#7af' },
    shadow_spirit:  { name:'暗之精灵',    hp:270, atk:42, def:8,  gold:210, exp:280, lv:22, color:'#74b', statusAtk:'freeze' },
    light_knight:   { name:'光之骑士',
    dieSfx: 'sfx_mon_die_light_knight',    hp:360, atk:44, def:17, gold:230, exp:310, lv:23, color:'#ff8' },
    wind_elemental: { name:'风暴元素',    hp:720, atk:54, def:15, gold:460, exp:620, lv:25, color:'#8cf', isBoss:true,
                     statusAtk:'freeze', desc:'天空之巅的远古风暴之灵，狂风与雷电具现而成。' },
    // === 暗黑城 ===
    dark_elf_soldier:{ name:'暗精灵卫兵',  hp:180, atk:20, def:8,  gold:105, exp:145, lv:13, color:'#76c' },
    shadow_beast:    { name:'暗影兽',      hp:210, atk:26, def:7,  gold:125, exp:170, lv:15, color:'#428', statusAtk:'curse' },
    ghost_knight:    { name:'幽灵骑士',
    dieSfx: 'sfx_mon_die_ghost_knight',    hp:250, atk:28, def:12, gold:145, exp:200, lv:17, color:'#7bf' },
    dark_priest:     { name:'暗黑祭司',    hp:170, atk:32, def:5,  gold:140, exp:190, lv:16, color:'#60c', statusAtk:'curse' },
    spider_queen:    { name:'蜘蛛女王',
    dieSfx: 'sfx_mon_die_spider_queen',    hp:500, atk:36, def:13, gold:350, exp:460, lv:19, color:'#a4d', isBoss:true, multiPhase:true, phase2Hp:180, phase2AtkBonus:16, bossSkill:{name:"蛛网陷阱",desc:"玩家跳过1回合",stunPlayer:1,rate:0.2}, bossPassive:{name:"毒液腺体",desc:"攻击附带3回合中毒(50%概率)",poisonProc:0.5}, statusAtk:'poison' },
    shadow_lord:     { name:'暗影领主',    hp:850, atk:50, def:18, gold:750, exp:950, lv:22, color:'#309', isBoss:true,
                     multiPhase:true, phase2Hp:400, phase2AtkBonus:15 },
  };
  return monsters[id] || monsters.goblin;
};

export const ENCOUNTER_TEXTS = {
  goblin:           '一只凶猛的哥布林突然从灌木丛中冲出，龇牙咧嘴地朝你扑来！',
  goblin2:          '两只哥布林哨兵从前方的树后跳了出来，手中的木棒挥舞得虎虎生风。',
  goblin_chief:     '一阵沉重的脚步声从深处传来——体型硕大的哥布林头目拨开树枝，怒气冲冲地瞪着你！',
  tau_beast:        '地面突然震动！一头巨大的牛头兵从营寨中冲撞而出，鼻孔喷着热气。',
  tau_chief:        '巨大的身影从阴影中浮现——牛头王手持战斧，每一步都让大地颤动。',
  zombie:           '腐臭的气味扑面而来！一只暗黑僵尸拖着腐烂的身躯，从泥土中爬出。',
  zombie2:          '更多的腐尸从地底钻出！它们的眼中闪烁着不祥的绿光。',
  thunder_goblin:   '雷光一闪！一只通体缠绕着电弧的哥布林站在废墟之上，朝你咧嘴一笑。',
  thunder_boss:     '天空中劈下数道惊雷，一只巨大的哥布林在雷光中现身——落雷凯诺，雷鸣废墟的主人！',
  poison_slime:     '紫色的毒雾在眼前凝聚，化作一只不断蠕动的猛毒史莱姆，发出滋滋的腐蚀声。',
  flame_goblin:     '热浪翻滚！一只浑身燃烧着烈焰的哥布林从火海中现身，空气都被烤得扭曲。',
  flame_boss:       '烈焰冲天而起！烈焰彼诺修张开燃烧的双臂，整个空间化为炼狱——「闯入者……化为灰烬吧！」',
  bone_dragon:      '黑暗最深处的寂静突然被打破——盗尸者骨狱息从满地尸骸中缓缓站起，骷髅眼眶中燃烧着幽蓝的火焰！',
  cursed_knight:    '金属的摩擦声由远及近——一名全身黑甲的被咒骑士拖着长剑从走廊深处走来。',
  shadow_mage:      '空气骤然变冷，一道黑影在走廊尽头凝聚成人形——暗影法师的法杖已经对准了你。',
  golem_guard:      '大地崩裂！地界守卫者从碎石中站起，庞大的石质身躯遮住了所有光线。',
  ice_witch:        '冰霜开始在墙壁上蔓延——冰封女巫冒昧图斯从暴风雪中走出，「又一个愚蠢的闯入者……」',
  cloud_gargoyle:   '一声尖啸划破长空！云海石像鬼从云端俯冲而下，石化的翅膀掀起狂风。',
  storm_hawk:       '雷云在头顶聚集，风暴战鹰展开闪烁着电光的羽翼，如闪电般掠来！',
  angel_fallen:     '六道黑翼在神殿门前展开——堕落天使长手持染血的圣剑，「踏入此地者，死。」',
  sky_dragon:       '神殿深处传来震耳欲聋的龙鸣——天空龙王展开遮天蔽日的巨翼，龙瞳中映出你的影子！',
  arad_demon:       '封印在颤抖中破碎——阿拉德魔王从混沌中降临，黑暗从未如此接近这个世界。',
  // === 格兰之森新增 ===
  cat_demon:         '一声尖锐的猫叫从树梢传来！一只双目发着绿光的猫妖从枝头跃下，利爪在月色下闪着寒光。',
  goblin_scout:      '灌木丛中传来窸窸窣窣的动静——一个哥布林侦察兵手持短矛，警惕地在林间巡逻。',
  wild_boar:         '灌木丛剧烈晃动，一头獠牙狰狞的狂暴野猪从密林中冲撞而出，地面都在它的蹄下颤抖！',
  swamp_zombie:      '沼泽中冒出一串气泡，一具裹满泥浆的沼泽腐尸缓缓站起，空洞的眼窝中闪烁着幽光。',
  dark_cat:          '周围的空气骤然变冷，一团黑雾在枝头凝聚成形——暗咒猫妖睁开了它的眼睛，瞳孔中旋转着古老的诅咒符文。',
  goblin_shaman:     '一阵古怪的吟唱声从不远处传来——哥布林萨满手持骨制法杖，身旁漂浮着发光的毒粉。',
  forest_guardian:   '大地裂开，古老的根系从地底迸发而出！森林守护者——一个由千年古木与藤蔓缠绕而成的巨像，缓缓睁开了它的眼睛。「凡人……你不该来此。」',
  // === 赫顿玛尔新增 ===
  puppet_master:     '诡异的笑声在走廊中回荡——一名疯狂人偶师拖着他的木偶向你走来，手中的提线人偶眼神竟像活物一般。',
  dark_elf_archer:   '一道黑影在远处的柱子上蹲伏——暗精灵弓箭手已经拉满了弓弦，箭尖对准了你的心脏。「又一个送上门的猎物……」',
  gbl_zealot:        '「为GBZ教义而献身——！」一个披着破旧教袍的狂热教徒从黑暗中冲出，手中的教典燃烧着不祥的火焰。',
  dark_sorcerer:     '魔法阵在你脚下突然亮起！暗黑术士从虚空中踏出，黑色的法袍下只露出两只闪烁着紫光的眼睛。',
  stone_golem:       '墙壁突然震动，石块自行拼合——一个三米高的石巨人拔地而起，空洞的眼窝中燃烧着魔法核心的光芒。',
  mad_alchemist:     '实验室的大门被炸开，浓烈的毒雾中走出一个狂笑的身影——疯狂炼金师腋下夹着各种冒着泡的药剂瓶，「新的实验材料送上门了！」',
  // === 天空之城新增 ===
  dragon_warrior:    '云层中掠过一道龙影——龙人战士展开布满鳞片的翅膀，从空中俯冲而下，手中龙枪直指你的胸口。',
  sky_patrol:        '云海上传来整齐的脚步声——天空巡游者们骑着云雾化作的坐骑，将你团团包围。',
  shadow_spirit:     '空气骤然凝结成冰晶——一团幽蓝的暗之精灵从墙缝中飘出，所过之处皆被寒霜覆盖。',
  light_knight:      '光芒刺眼！光之骑士从神殿中缓步踏出，身周萦绕着神圣的光环，银白色的盔甲映出你的影子。「此地乃禁域，凡人止步。」',
  wind_elemental:    '狂风呼啸，云层被撕开一道巨大的裂缝——风暴元素在雷霆与龙卷中显形，它没有面孔，只有无尽的旋风和闪电在体内翻涌。「我是天空的意志，挑战我者——必化作尘埃。」',
  // === 暗黑城 ===
  dark_elf_soldier:   '火把的光芒在洞穴墙壁上投下扭曲的影子。前方转角，一名暗精灵卫兵从阴影中现身，手中的弯刀泛着幽蓝的冷光。',
  shadow_beast:       '黑暗中传来低沉的咆哮——不是人类，也不是野兽。暗影兽从岩石的裂缝中挤出，它的形体在明灭的火光中不断扭曲变形。',
  ghost_knight:       '地下陵墓的寂静被打破——一身穿古代铠甲的幽灵骑士骑着半透明的战马，从石壁中穿透而出！空洞的眼窝中燃烧着幽蓝的鬼火。',
  dark_priest:        '「愚蠢的闯入者……」低沉的声音从上方传来。暗黑祭司悬浮在祭坛之上，周身的黑气化作锁链向四周蔓延。',
  spider_queen:       '蛛丝从四面八方垂下，整个大厅化作了巨大的蛛巢。在最深处，蜘蛛女王从丝茧中优雅地走出——她的每一只眼睛都盯着你。',
  shadow_lord:        '要塞最深处的王座上，暗影领主缓缓站起。他的盔甲下没有肉体——只有无尽的黑暗和上千条亡魂的哀嚎。他举起手中的亡灵之刃。',
};

export const BOSS_CLUES = {
  goblin_chief: [
    { text:'前方传来沉重的脚步声和粗重的喘息，树枝被什么东西粗暴地折断。', choices:[
      { text:'继续前进（脚步越来越近了）', stage:1 },
      { text:'躲到大树后面观察', stage:1, msg:'你屏住呼吸……一个巨大的身影从树丛中穿过。' },
    ]},
    { text:'地面的震动越来越明显——那不是普通的哥布林。前方的空旷地中，篝火的余烬还在燃烧，周围散落着被啃光的骨头。', choices:[
      { text:'做好战斗准备，踏入空地', next:'battle_goblin_chief' },
    ]},
  ],
  bone_dragon: [
    { text:'密林深处传来低沉而有节奏的呼吸声……不是人类，也不是野兽。空气中弥漫着尸腐的气味。', choices:[
      { text:'循着声音前进（呼吸声越来越响了）', stage:1 },
    ]},
    { text:'地面开始微微震动，仿佛地下有什么巨物正在苏醒。周围的树木开始枯萎，枝叶在你经过时自动凋零。', choices:[
      { text:'踏入诅咒之地的核心', next:'battle_bone_dragon' },
    ]},
  ],
  sky_dragon: [
    { text:'神殿的深处传来深沉的呼吸声，整个地板随着呼吸的节奏起伏。空气中弥漫着远古魔力的气息。', choices:[
      { text:'沿着长廊前进（每走一步，龙威就越发压迫）', stage:1 },
    ]},
    { text:'长廊尽头，一道巨大的青铜门半掩着。门缝中透出的光芒是金色的，但你隐约看到门后盘踞着巨大的黑影。', choices:[
      { text:'推开青铜大门', next:'battle_sky_dragon' },
    ]},
  ],
};

export function showBattleReveal(monsterId, parentScene) {
  const mon = getMonsterData(monsterId);
  const main = document.getElementById('main');
  const monImg = getMonsterImage(monsterId);
  let html = `<div class="story-box" style="border-color:${mon.color};text-align:center;">
    <div style="font-size:40px;margin-bottom:6px;">${monImg}</div>
    <span style="color:${mon.color};font-size:18px;font-weight:700;">${mon.name}</span>
    <span style="color:var(--dim);font-size:11px;display:block;margin-top:4px;">出现了！</span>
  </div>
  <button class="choice-btn" onclick="startCombat('${monsterId}','${parentScene}')" style="font-size:14px;text-align:center;">⚔️ 迎战！</button>`;
  main.innerHTML = html;
};

export function showBossClue(monsterId, stage, parentScene) {
  const clues = BOSS_CLUES[monsterId];
  if(!clues || stage >= clues.length) { startCombat(monsterId, parentScene); return; }
  const clue = clues[stage];
  const main = document.getElementById('main');
  let html = `<div class="story-box" style="border-color:var(--red);">
    <strong style="color:var(--red);font-size:13px;">⚠ 不祥的预感…</strong>\n\n${clue.text}</div>
    <div class="choices">`;
  clue.choices.forEach((c,i) => {
    if(c.next) {
      html += `<button class="choice-btn" onclick="startCombat('${c.next.replace('battle_','')}','${parentScene}')">${i+1}. ${c.text}</button>`;
    } else if(c.stage !== undefined) {
      html += `<button class="choice-btn" onclick="showBossClue('${monsterId}',${c.stage},'${parentScene}')">${i+1}. ${c.text}</button>`;
    }
    if(c.msg) html += `<div style="font-size:11px;color:var(--dim);margin:4px 0;text-align:center;font-style:italic;">${c.msg}</div>`;
  });
  html += `</div>`;
  main.innerHTML = html;
};

export function pickMonsterForRegion(regionId, isBoss, isElite) {
  const pools = {
    forest: {
      normal: ['goblin','goblin2','goblin_scout','cat_demon','wild_boar','goblin_shaman','zombie','swamp_zombie','tau_beast','dark_cat','thunder_goblin','flame_goblin'],
      elite:  ['goblin_chief','tau_chief','thunder_boss','poison_slime','flame_goblin','dark_cat','forest_guardian'],
      boss:   ['goblin_chief','cat_demon','thunder_boss','poison_slime','tau_chief','forest_guardian','flame_boss','bone_dragon'],
    },
    hetonmar: {
      normal: ['cursed_knight','shadow_mage','puppet_master','dark_elf_archer','gbl_zealot','dark_sorcerer','stone_golem'],
      elite:  ['cursed_knight','shadow_mage','dark_sorcerer','stone_golem','dark_elf_archer','puppet_master'],
      boss:   ['golem_guard','ice_witch','mad_alchemist'],
    },
    sky_city: {
      normal: ['storm_hawk','dragon_warrior','sky_patrol','shadow_spirit','light_knight'],
      elite:  ['storm_hawk','dragon_warrior','light_knight','sky_patrol','shadow_spirit'],
      boss:   ['cloud_gargoyle','angel_fallen','sky_dragon','wind_elemental'],
    },
    dark_city: {
      normal: ['dark_elf_soldier','shadow_beast','ghost_knight','dark_priest'],
      elite:  ['shadow_beast','ghost_knight','dark_priest'],
      boss:   ['spider_queen','shadow_lord'],
    },
  };
  
  const pool = pools[regionId] || pools.forest;
  const list = isBoss ? pool.boss : (isElite ? pool.elite : pool.normal);
  return list[Math.floor(Math.random() * list.length)];
};

// Boss 按地下城匹配（避免哥布林头目出现在骨狱息副本）
const DUNGEON_BOSS_MAP = {
  // 格兰之森：低→高
  gf_dark_forest: ['goblin_chief','cat_demon'],
  gf_thunder: ['thunder_boss'],
  gf_poison: ['poison_slime','tau_chief'],
  gf_flame: ['tau_chief','forest_guardian','flame_boss'],
  gf_dark_thunder: ['flame_boss','bone_dragon'],
  // 赫顿玛尔：低→高
  ht_dungeon: ['golem_guard'],
  ht_gbl_shrine: ['golem_guard','ice_witch'],
  ht_magic: ['ice_witch','mad_alchemist'],
  ht_ice_lair: ['mad_alchemist'],
  // 暗黑城：低→高
  dc_outpost: ['spider_queen'],
  dc_cavern: ['spider_queen','shadow_lord'],
  dc_citadel: ['shadow_lord'],
  // 天空之城：低→高
  sky_gate: ['cloud_gargoyle'],
  sky_dragon_tower: ['cloud_gargoyle','angel_fallen'],
  sky_temple: ['angel_fallen'],
  sky_dark_corridor: ['angel_fallen','sky_dragon'],
  sky_dragon_lair: ['sky_dragon','wind_elemental'],
};

export function pickBossForDungeon(dungeonId, regionId) {
  const matched = DUNGEON_BOSS_MAP[dungeonId];
  if(matched) return matched[Math.floor(Math.random() * matched.length)];
  // fallback: 使用区域池
  return pickMonsterForRegion(regionId, true, false);
};

export function pickEliteModifier() {
  return ELITE_MODIFIERS[Math.floor(Math.random() * ELITE_MODIFIERS.length)];
};

export function pickDungeonModifier() {
  // 30% 概率获得修饰符
  if(Math.random() > 0.3) return null;
  return DUNGEON_MODIFIERS[Math.floor(Math.random() * DUNGEON_MODIFIERS.length)];
};

export function getMonsterImage(id) {
  const map = {
    goblin:'monster_goblin', goblin2:'monster_goblin2', goblin_chief:'monster_goblin_chief',
    tau_beast:'monster_tau', tau_chief:'monster_tau_chief',
    zombie:'monster_zombie', zombie2:'monster_zombie2',
    thunder_goblin:'monster_thunder', thunder_boss:'monster_thunder_boss',
    poison_slime:'monster_poison', flame_goblin:'monster_flame', flame_boss:'monster_flame_boss',
    bone_dragon:'monster_bone_dragon', cursed_knight:'monster_cursed_knight',
    shadow_mage:'monster_shadow_mage', golem_guard:'monster_golem',
    ice_witch:'monster_ice_witch', cloud_gargoyle:'monster_gargoyle',
    storm_hawk:'monster_storm_hawk', angel_fallen:'monster_fallen_angel',
    sky_dragon:'monster_sky_dragon', arad_demon:'monster_arad_demon',
    // 新增怪物（使用fallback SVG）
    cat_demon:'monster_cat_demon', goblin_scout:'monster_goblin_scout',
    wild_boar:'monster_wild_boar', swamp_zombie:'monster_swamp_zombie',
    dark_cat:'monster_dark_cat', goblin_shaman:'monster_goblin_shaman',
    forest_guardian:'monster_forest_guardian',
    puppet_master:'monster_puppet', dark_elf_archer:'monster_dark_elf',
    gbl_zealot:'monster_gbl', dark_sorcerer:'monster_sorcerer',
    stone_golem:'monster_stone_golem', mad_alchemist:'monster_alchemist',
    dragon_warrior:'monster_dragon_warrior', sky_patrol:'monster_sky_patrol',
    shadow_spirit:'monster_shadow_spirit', light_knight:'monster_light_knight',
    wind_elemental:'monster_wind_elemental',
    // 暗黑城
    dark_elf_soldier:'monster_dark_elf_soldier', shadow_beast:'monster_shadow_beast',
    ghost_knight:'monster_ghost_knight', dark_priest:'monster_dark_priest',
    spider_queen:'monster_spider_queen', shadow_lord:'monster_shadow_lord',
    dark_knight_sky:'monster_dark_knight_sky', corridor_mage:'monster_corridor_mage',
    dragon_soldier:'monster_dragon_soldier', dragon_centurion:'monster_dragon_centurion',
  };
  const file = map[id];
  if(!file) return getMonsterFallbackSVG(id);
  return `<img src="assets/${file}.png" style="width:110px;height:130px;object-fit:contain;" onerror="this.outerHTML=getMonsterFallbackSVG('${id}')" alt="${id}">`;
};

export function getMonsterFallbackSVG(id) {
  const color = getMonsterData(id).color || '#aaa';
  const isBoss = getMonsterData(id).isBoss;
  return `<svg viewBox="0 0 100 120" style="width:110px;height:130px;">
<ellipse cx="50" cy="110" rx="${isBoss?32:24}" ry="5" fill="#050505" opacity="0.4"/>
<ellipse cx="50" cy="70" rx="${isBoss?22:16}" ry="${isBoss?28:22}" fill="${color}" opacity="0.7"/>
<ellipse cx="50" cy="48" rx="${isBoss?18:14}" ry="${isBoss?16:12}" fill="${color}" opacity="0.85"/>
<ellipse cx="44" cy="46" rx="3" ry="4" fill="#fff" opacity="0.8"/>
<ellipse cx="56" cy="46" rx="3" ry="4" fill="#fff" opacity="0.8"/>
<circle cx="44" cy="45" r="1.5" fill="#111"/>
<circle cx="56" cy="45" r="1.5" fill="#111"/>
${isBoss?`<circle cx="50" cy="30" r="10" fill="none" stroke="${color}" stroke-width="2" opacity="0.5"/><circle cx="50" cy="30" r="5" fill="${color}" opacity="0.2"/>`:''}
${isBoss?`<text x="50" y="105" text-anchor="middle" font-size="8" fill="${color}" font-weight="bold">BOSS</text>`:''}
</svg>`;
};
